import createPersistedState from 'vuex-persistedstate'

export default ({ store }: any) => {
  createPersistedState({
    key: 'apc',
    paths: ['authUser', 'auction.params'], // localStorageに保存したいstoreを入れる
  })(store)
}
